<template>
  <div class="modal fade light " id="modalWheel" ref="bank" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-background modal-lg">
      <div class="modal-content">
        <div class=" ">
          <header class="modal-card-head">
            <p class="modal-card-title">กงล้อ</p><button aria-label="close" data-dismiss="modal"
              class="delete"></button>
          </header>
          <section class="modal-card-body">

            <div class="modal-body -modal-body text-center">
              <div class="detailwd accountct text-center">
                <div data-v-2ad17728="" data-v-7b8ad404="" data-v-92268d78="" id="wheel-game">
                  <div data-v-2ad17728="" data-v-7b8ad404="" class="wheel-game"
                    style="border-color: rgb(249, 220, 78);">
                    <div data-v-2ad17728="" data-v-7b8ad404="">
                      <img data-v-2ad17728="" data-v-7b8ad404="" src="/static/img/user/spin.png" width="120" alt="" />
                    </div>
                    <div data-v-2ad17728="" data-v-7b8ad404="" class="wheel-detail">
                      <h5 data-v-2ad17728="" data-v-7b8ad404="">
                        เครดิตกงล้อ {{ UserInfo.internalWallet.prizeWallet }}
                      </h5>
                      <small data-v-2ad17728="" data-v-7b8ad404="">ใช้ 50 ต่อการหมุนกงล้อ 1 ครั้ง</small>
                      <br /><br />
                      <div class="text-center">
                        <button @click="open()" class="button full-50 is-primary">
                          หมุนกงล้อ
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </section>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { UserInfoMixins } from '@/mixins/UserInfo.js'
import { open } from '@/services/modules/spin.js'

export default {
  name: 'WheelForm',
  mixins: [UserInfoMixins],

  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
      'getPrefix',
    ]),
  },
  methods: {
    async open() {
      setTimeout(async () => {
        await open((res) => {
          if (res.status) {
            return this.$swal.fire(res.message, '', 'success')
          } else {
            return this.$swal.fire(res.message, '', 'error')
          }
        })
      }, 1500)
    },
  },
}
</script>
<style scoped>
.modal-dialog[data-v-6c8d75ed] {
  min-width: 720px;
}

.modal-dialog .modal-content[data-v-6c8d75ed] {
  background-color: #151515;
  border-radius: 10px;
  box-shadow: 0 0 5px #000;
}

.modal-dialog .modal-content .modal-body .header-label[data-v-6c8d75ed] {
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  padding: 0.8rem 0.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(180deg, #a44bc9, #6200b5);
  border-radius: 4px;
}

.modal-dialog .modal-content .modal-header .btn-close[data-v-6c8d75ed] {
  color: #fff;
  background: none;
  width: auto;
  height: auto;
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(var(--bs-modal-header-padding-y) * -0.5) calc(var(--bs-modal-header-padding-x) * -0.5) calc(var(--bs-modal-header-padding-y) * -0.5) auto;
}

.modal-dialog .modal-content .modal-header[data-v-6c8d75ed] {
  color: #fff;
  border-bottom: none;
  padding: 0.225rem 0.5rem;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-dialog .modal-content .modal-body[data-v-6c8d75ed] {
  padding-top: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

#cashback .blog-cashback[data-v-4ad267e1] {
  padding: 1rem 1rem 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
}

.blog-data-amount h2[data-v-4ad267e1] {
  color: #f7ac03;
  font-weight: 600;
  font-size: 2.5rem;
  margin: 0;
}

table,
td,
th {
  border: 1px solid;
  padding: 5px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  padding: 5px;
}

#comp-list-bonus-other {
  display: grid;
  gap: 7px;
  grid-template-areas: '. . ';
}
</style>



// WEBPACK FOOTER //
// src/components/form/WheelForm.vue